/* eslint-disable react/prop-types */
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ukUA } from '@mui/x-date-pickers/locales';
import { t } from '../i18n/translations';
import usePickerLogic from '../hooks/usePickerLogic';
import { Container, Language, GoBack, GoBackLink } from './Picker.styles';
import BookingForm from './BookingForm';
import BookingSummary from './BookingSummary';

dayjs.extend(updateLocale);
const weekStartDay = Number(window.__ENV__?.WEEK_START_DAY ?? 1);
dayjs.updateLocale('en', { weekStart: weekStartDay });
dayjs.updateLocale('uk', { weekStart: weekStartDay });

export default function MaterialUIPickers() {
    const state = usePickerLogic();
    const {
        show, setShow, lang,
        handleChangeLanguage,
        contactNotFound,
    } = state;

    const botUsername = window.__ENV__?.TELEGRAM_BOT_USERNAME;

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={lang === 'ua' ? 'uk' : 'en'}
            localeText={lang === 'ua' ? ukUA.components.MuiLocalizationProvider.defaultProps.localeText : 'en'}
        >
            {/* Language switcher */}
            {show !== 'Checkout' && (
                <Language item alignItems="flex-end">
                    <FormControl size="small">
                        <InputLabel id="lang-label">{t(lang, 'language')}</InputLabel>
                        <Select value={lang} label={t(lang, 'language')} onChange={handleChangeLanguage}>
                            <MenuItem value="ua">🇺🇦</MenuItem>
                            <MenuItem value="en">🇺🇸</MenuItem>
                        </Select>
                    </FormControl>
                </Language>
            )}

            {/* Contact not found — user hasn't shared phone via bot yet */}
            {contactNotFound && (
                <Box sx={{ textAlign: 'center', p: 4 }}>
                    <Typography variant="h6" gutterBottom>
                        {t(lang, 'contactNotFoundTitle')}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        {t(lang, 'contactNotFoundMessage')}
                    </Typography>
                    {botUsername && (
                        <Button
                            variant="contained"
                            href={`https://t.me/${botUsername}`}
                        >
                            {t(lang, 'openBot')}
                        </Button>
                    )}
                </Box>
            )}

            {/* Main widget */}
            {!contactNotFound && show === 'Tool' && (
                <Container container>
                    <BookingForm  {...state} />
                    <BookingSummary {...state} />
                </Container>
            )}

            {/* Legacy Monobank redirect back link */}
            {show === 'Checkout' && (
                <GoBack onClick={() => setShow('Tool')}>
                    <GoBackLink>⬅ {t(lang, 'goBack')}</GoBackLink>
                </GoBack>
            )}
            <div id="checkout-container" style={show === 'Tool' ? { display: 'none' } : { display: 'block' }} />
        </LocalizationProvider>
    );
}
